import ConsumerMailboxOptions from 'owa-service/lib/contract/ConsumerMailboxOptions';
import getConsumerMailboxOperation from 'owa-service/lib/operation/getConsumerMailboxOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function getConsumerMailboxOptions(): Promise<ConsumerMailboxOptions> {
    return getConsumerMailboxOperation({
        Header: getJsonRequestHeader(),
    }).then(response => {
        return response.Options;
    });
}
